import(/* webpackMode: "eager" */ "/app/app/(front)/page.tsx");
